







import Vue from 'vue'

export default Vue.extend({
  name: 'DdLoading',

  metaInfo() {
    if (this.$route.params.title) {
      return { title: `${this.$route.params.title}` }
    } else {
      return {
        title: `${process.env.VUE_APP_TITLE}`,
        titleTemplate: `%s `,
      }
    }
  },
})
